// Bank names supplied in banks.html for the settlement cheque dropdown.
export const BANK_NAMES = [
  'SBP',
  'Al Baraka Bank (Pakistan) Limited.',
  'Allied Bank Limited.',
  'Askari Bank Limited',
  'Bank Alfalah Limited.',
  'Bank Al-Habib Limited.',
  'BankIslami Pakistan Limited.',
  'Burj Bank Limited.',
  'Citi Bank N.A.',
  'Deutsche Bank A.G.',
  'Dubai Islamic Bank Pakistan Limited.',
  'Faysal Bank Limited.',
  'First Women Bank Limited.',
  'Habib Bank Limited.',
  'Habib Metropolitan Bank Limited.',
  'Industrial and Commercial Bank of China',
  'Industrial Development Bank of Pakistan.',
  'JS Bank Limited.',
  'MCB Bank Limited.',
  'MCB Islamic Bank Limited.',
  'Meezan Bank Limited.',
  'National Bank of Pakistan.',
  'NIB Bank Limited.',
  'S.M.E. Bank Limited.',
  'Samba Bank Limited.',
  'Silk Bank Limited.',
  'Sindh Bank Limited.',
  'Soneri Bank Limited.',
  'Standard Chartered Bank (Pakistan) Limited.',
  'Summit Bank Limited.',
  'The Bank of Khyber.',
  'The Bank of Punjab.',
  'The Bank of Tokyo-Mitsubishi Limited.',
  'The Punjab Provincial Cooperative Bank Limited.',
  'United Bank Limited.',
  'Zarai Taraqiati Bank Limited.',
  'Advans Micro Finance Bank Limited.',
  'APNA Micro Finance Bank Limited.',
  'FINCA Micro Finance Bank Limited.',
  'Khushhali Bank Limited.',
  'Mobilink Microfinance Bank Limited.',
  'NRSP Micro Finance Bank Limited.',
  'Pak Oman Micro Finance Bank Limited.',
  'Tameer Micro Finance Bank Limited.',
  'The First Micro Finance Bank Limited.',
  'U Micro Finance Bank Limited.',
] as const
